module.exports = __webpack_public_path__ + "img/free-icon-telegram-2111646.2cb215c0.png";